import api from "./api";

function toQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.set(key, String(value));
    }
  });
  return query.toString();
}

export async function listProcurementOrders(filters = {}) {
  const query = toQuery(filters);
  const res = await api.get(`/procurement-orders${query ? `?${query}` : ""}`);
  return res.data;
}

export async function getProcurementOrder(id) {
  const res = await api.get(`/procurement-orders/${id}`);
  return res.data;
}

export async function createProcurementOrder(payload) {
  const res = await api.post("/procurement-orders", payload);
  return res.data;
}

export async function updateProcurementOrder(id, payload) {
  const res = await api.put(`/procurement-orders/${id}`, payload);
  return res.data;
}

export async function linkProcurementOrderTarget(id, payload) {
  const res = await api.patch(`/procurement-orders/${id}/link-target`, payload);
  return res.data;
}

export async function startProcurementOrderTuPunchout(id, payload = {}) {
  const res = await api.post(`/procurement-orders/${id}/integrations/tu/punchout`, payload);
  return res.data;
}

export async function sendProcurementOrder(id) {
  const res = await api.post(`/procurement-orders/${id}/send`);
  return res.data;
}

export async function confirmProcurementOrder(id) {
  const res = await api.post(`/procurement-orders/${id}/confirm`);
  return res.data;
}

export async function approveProcurementOrder(id) {
  const res = await api.post(`/procurement-orders/${id}/approve`);
  return res.data;
}

export async function closeProcurementOrder(id) {
  const res = await api.post(`/procurement-orders/${id}/close`);
  return res.data;
}

export async function reviewProcurementOrder(id, payload = {}) {
  const res = await api.post(`/procurement-orders/${id}/review`, payload);
  return res.data;
}

export async function rejectProcurementOrder(id, payload = {}) {
  const res = await api.post(`/procurement-orders/${id}/reject`, payload);
  return res.data;
}

export async function markProcurementOrderOrdered(id, payload = {}) {
  const rawPayload = payload && typeof payload === "object" ? payload : {};
  const externalOrderId = String(rawPayload.externalOrderId || "").trim();
  const supplierOrderReference = String(rawPayload.supplierOrderReference || "").trim();
  const note = String(rawPayload.note || "").trim();
  const hasManualConfirmation = rawPayload.manualConfirmation === true;
  const hasEvidence = Boolean(externalOrderId || supplierOrderReference);

  const resolvedPayload =
    hasEvidence || hasManualConfirmation
      ? {
          ...rawPayload,
          note: hasManualConfirmation ? note || "Handmatig bevestigd vanuit Logboek24" : note,
        }
      : {
          ...rawPayload,
          manualConfirmation: true,
          note: note || "Handmatig bevestigd vanuit Logboek24",
        };

  const res = await api.post(`/procurement-orders/${id}/order`, resolvedPayload);
  return res.data;
}

export async function receiveProcurementOrderPartial(id, payload = {}) {
  const res = await api.post(`/procurement-orders/${id}/receive-partial`, payload);
  return res.data;
}

export async function receiveProcurementOrder(id, payload = {}) {
  const res = await api.post(`/procurement-orders/${id}/receive`, payload);
  return res.data;
}

export async function listSuppliers(searchOrOptions = "", options = {}) {
  const resolved =
    searchOrOptions && typeof searchOrOptions === "object"
      ? searchOrOptions
      : { search: searchOrOptions, ...(options || {}) };
  const query = toQuery(resolved);
  const res = await api.get(`/procurement-orders/suppliers${query ? `?${query}` : ""}`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function createSupplier(payload) {
  const res = await api.post("/procurement-orders/suppliers", payload);
  return res.data;
}

export async function updateSupplier(id, payload) {
  const res = await api.patch(`/procurement-orders/suppliers/${id}`, payload);
  return res.data;
}
